import { Box, Skeleton, Typography } from '@mui/material';

interface CountBadgeProps {
  count: number | undefined;
}

/**
 * Pure UI component for displaying a count badge
 * Used in the Notes to Review card header
 */
export const CountBadge: React.FC<CountBadgeProps> = ({ count }) => {
  return (
    <Box
      sx={{
        borderRadius: '100%',
        backgroundColor: 'secondary.main',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '2rem',
        height: '2rem',
      }}
    >
      <Typography sx={{ color: 'common.white', fontSize: '0.875rem', fontWeight: 600 }}>
        {count !== undefined ? (
          count
        ) : (
          <Skeleton variant="circular" sx={{ width: '80%', height: '80%' }} />
        )}
      </Typography>
    </Box>
  );
};
